<template>
  <my-modal ref="popup">
    <div class="col-12">
      <div class="formWrap blockWrapper">
        <h4 class="formTitle">{{ title }}</h4>
        <p v-if="subtitle" class="formSubtitle">{{ subtitle }}</p>
        <MyInput label="Имя ребёнка" v-model="name" placeholder="Введите имя ребёнка" />
        <VueSelect label="Возраст ребёнка" :options="ageOptions" v-model="ageCategory" />
        <label class="aboveLabel">Как называется ваша команда? Если у вас нет команды, напишите 'у меня нет команды'</label>
        <MyInput v-model="teamName" />
        <VueSelect
          label="Сколько планируется участников в команде?"
          :options="teamSizeOptions"
          v-model="teamSize"
        />
        <MyInput
          label="Номер телефона родителя или ребёнка"
          v-model="phone"
          phoneInput
        />
        <div class="form-group">
          <input id="consent" type="checkbox" v-model="consent" required />
          <label for="consent">Отправляя данную форму, я даю согласие на обработку персональных данных</label>
        </div>
        <my-button
          cls="pink"
          :disabled="isSubmitDisabled"
          @click="submitForm"
          style="width:100%; margin-top:1.25rem;"
        >
          Отправить
        </my-button>
      </div>
    </div>
  </my-modal>
</template>

<script>
import MyModal from "./UI/MyModal";
import MyInput from "./UI/MyInput";
import VueSelect from "./UI/VueSelect";
import MyButton from "./UI/MyButton";

export default {
  name: "ChildInfoModal",
  components: { MyModal, MyInput, VueSelect, MyButton },
  props: {
    title: {
      type: String,
      default: "Присоединяйтесь к Про100 Квиз. Дети!"
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      name: "",
      ageCategory: "",
      teamName: "",
      teamSize: "",
      phone: "",
      consent: false,
      resolvePromise: null,
      rejectPromise: null
    };
  },
  computed: {
    ageOptions() {
      return [
        { id: "8-10 лет", title: "8-10 лет" },
        { id: "11-13 лет", title: "11-13 лет" }
      ];
    },
    teamSizeOptions() {
      return [
        { id: "solo", title: "Я один (одна)" },
        { id: "2", title: "2" },
        { id: "3", title: "3" },
        { id: "4", title: "4" },
        { id: "5", title: "5" },
        { id: "6", title: "6" },
        { id: "7", title: "7" },
        { id: "8", title: "8" }
      ];
    },
    isSubmitDisabled() {
      const phoneDigits = this.phone.replace(/\D/g, '');
      return (
        !this.name.trim() ||
        !this.ageCategory ||
        !this.teamName.trim() ||
        !this.teamSize ||
        !this.phone.trim() ||
        !this.consent ||
        phoneDigits.length < 7
      );
    }
  },
  methods: {
    show() {
      this.$refs.popup.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    close() {
      this.$refs.popup.close();
      if (this.rejectPromise) this.rejectPromise();
    },
    async submitForm() {
      // Validate required fields
      if (!this.name.trim() || !this.ageCategory || !this.teamName.trim() || !this.teamSize || !this.phone.trim() || !this.consent) {
        this.$toast.error('Пожалуйста, заполните все поля и дайте согласие');
        return;
      }
      // Validate phone number length: at least 7 digits
      const digits = this.phone.replace(/\D/g, '');
      if (digits.length < 7) {
        this.$toast.error('Пожалуйста, введите корректный номер телефона (мин. 7 цифр)');
        return;
      }
      const data = {
        name: this.name,
        ageCategory: this.ageCategory,
        teamName: this.teamName,
        teamSize: this.teamSize,
        phone: this.phone
      };
      try {
        await this.axios.post('https://p100quiz.pythonanywhere.com/api/child_registration', data);
        this.$toast.success('Данные успешно отправлены');
      } catch (err) {
        this.$toast.error('Ошибка при отправке данных на сервер');
        return;
      }
      this.$refs.popup.close();
      if (this.resolvePromise) this.resolvePromise(data);
      this.name = this.ageCategory = this.teamName = this.teamSize = this.phone = "";
      this.consent = false;
    }
  }
};
</script>

<style scoped>
.blockWrapper {
  max-width: 24rem;
  padding: 0;
}
.formWrap {
  background: #33347E;
  border-radius: 1rem;
  padding: 0;
}
.formTitle {
  font-size: 10px;
  line-height: 24px;
  letter-spacing: 0.165em;
  text-transform: uppercase;
  opacity: 0.6;
  text-align: left;
  margin-bottom: 0.625rem;
}
.formSubtitle {
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: left;
  margin-bottom: 20px;
}
/* Красная звездочка у обязательных полей */
:deep(label)::after {
  content: ' *';
  color: darkred;
  margin-left: 0.2rem;
  font-size: 1.2em;
  font-weight: 700;
}
.aboveLabel {
  display: block;
  color: #fff;
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 1.25rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin: 1.75rem auto 0.5rem;
}
/* Override input placeholder color only in this form */
:deep(input::placeholder),
:deep(input::-webkit-input-placeholder) {
  color: rgba(255, 255, 255, 0.7);
}
:deep(input::-ms-input-placeholder) {
  color: rgba(255, 255, 255, 0.7);
}
/* Disabled state for submit button in this form */
:deep(.button:disabled) {
  opacity: 1 !important;
  filter: brightness(0.7);
  cursor: not-allowed;
}
</style> 